import React, { useContext } from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { ConfigContext } from 'containers/App';

const Abbr = chunks => <abbr>{chunks}</abbr>;
const Address = chunks => <address>{chunks}</address>;
const Bold = chunks => <b>{chunks}</b>;
const BlockQuote = chunks => <blockquote>{chunks}</blockquote>;
const Center = chunks => <p className="text-center">{chunks}</p>;
const Cite = chunks => <cite>{chunks}</cite>;
const Dd = chunks => <dd>{chunks}</dd>;
const Dl = chunks => <dl>{chunks}</dl>;
const Dt = chunks => <dt>{chunks}</dt>;
const Em = chunks => <em>{chunks}</em>;
const ExternalAnchorLink = (chunks) => {
  const [chunk] = chunks;
  const chunkIndex = chunk?.indexOf('|') ?? -1;
  const url = chunk && chunkIndex > 0 ? chunk.substring(0, chunkIndex) : chunks;
  const text = chunk && chunkIndex > 0 ? chunk.substring(chunkIndex + 1) : chunks;
  return <a href={ url } target="_blank" rel="noopener noreferrer" className="external-link">{ text }</a>;
};
const H1 = chunks => <h1>{chunks}</h1>;
const H2 = chunks => <h2>{chunks}</h2>;
const H3 = chunks => <h3>{chunks}</h3>;
const H4 = chunks => <h4>{chunks}</h4>;
const H5 = chunks => <h5>{chunks}</h5>;
const H6 = chunks => <h6>{chunks}</h6>;
const Italic = chunks => <i>{chunks}</i>;
const LatinList = chunks => <ol className="latin-list">{chunks}</ol>;
const ListItem = chunks => <li>{chunks}</li>;
const Mark = chunks => <mark>{chunks}</mark>;
const Menu = chunks => <menu>{chunks}</menu>;
const OrderedList = chunks => <ol>{chunks}</ol>;
const Paragraph = chunks => <p>{chunks}</p>;
const Pre = chunks => <pre>{chunks}</pre>;
const Quote = chunks => <q>{chunks}</q>;
const RedText = chunks => <span className="red">{chunks}</span>;
const RomanList = chunks => <ol className="roman-list">{chunks}</ol>;
const StrikeThrough = chunks => <s>{chunks}</s>;
const Span = chunks => <span>{chunks}</span>;
const Strong = chunks => <strong>{chunks}</strong>;
const SubText = chunks => <sub>{chunks}</sub>;
const SuperText = chunks => <sup>{chunks}</sup>;
const Underline = chunks => <u>{chunks}</u>;
const UnorderedList = chunks => <ul>{chunks}</ul>;

const LocalisedMessage = ({ id, values, defaultMessage }) => {
  const configContext = useContext(ConfigContext);

  return (<FormattedMessage
    id={ id }
    values={ {
      abbr: Abbr,
      address: Address,
      b: Bold,
      blockquote: BlockQuote,
      br: <br />,
      center: Center,
      cite: Cite,
      dd: Dd,
      dl: Dl,
      dt: Dt,
      em: Em,
      hr: <hr />,
      h1: H1,
      h2: H2,
      h3: H3,
      h4: H4,
      h5: H5,
      h6: H6,
      i: Italic,
      li: ListItem,
      ll: LatinList,
      mark: Mark,
      menu: Menu,
      ol: OrderedList,
      p: Paragraph,
      pre: Pre,
      q: Quote,
      red: RedText,
      rl: RomanList,
      s: StrikeThrough,
      span: Span,
      strong: Strong,
      sub: SubText,
      sup: SuperText,
      // eslint-disable-next-line react/no-unstable-nested-components
      supportlink: chunks => <a href={ configContext?.supportUrl } target="blank">{chunks}</a>,
      u: Underline,
      ul: UnorderedList,
      // eslint-disable-next-line react/no-unstable-nested-components
      websitelink: chunks => <a href={ configContext?.websiteUrl } target="blank">{chunks}</a>,
      externallink: ExternalAnchorLink,
      ...values
    } }
    defaultMessage={ defaultMessage !== null ? defaultMessage : id }
  />);
};

LocalisedMessage.propTypes = {
  id: PropTypes.string.isRequired,
  values: PropTypes.shape(),
  defaultMessage: PropTypes.string
};

LocalisedMessage.defaultProps = {
  values: null,
  defaultMessage: null
};

export default LocalisedMessage;
